// Environmental image block (official Barverse renders).
export default function ImageBlock({ src, alt, className = "", eager = false }) {
  return (
    <figure className={`relative overflow-hidden rounded-2xl border border-bv-line bg-bv-panel ${className}`}>
      <img
        src={src}
        alt={alt}
        loading={eager ? "eager" : "lazy"}
        decoding="async"
        className="h-full w-full object-cover"
      />
    </figure>
  );
}
